module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/mix-match-f98efba04036db4525e327988992677b.png";